import React from 'react'
import { observer } from 'mobx-react'
import classnames from 'classnames'
import _ from 'lodash'

// Represents a series of data in the bar chart (e.g. "male")
const Series = ({
  seriesName,
  i,
  numSeries,
  height,
  xScale,
  yScale,
  analysis,
  color
}) => {
  const width = xScale.bandwidth() / numSeries

  // In addition to visible bars, calculate the width for transparent
  // "target" elements for each bar, which handle mouse events.
  // The reason for target elements is to allow the target to be 100% high
  // and wide enough to fill gaps, so that the user doesn't have to hover
  // over very short bars.
  const targetWidth = i === numSeries - 1
    ? width + xScale.padding() * xScale.step()
    : width

  return (
    <g>
      {
        _.map(analysis.pyramids[seriesName], pyramid => (
          <g key={seriesName + pyramid.age}>
            <rect
              className={classnames({
                bar: true,
                hovered: (
                  analysis.hoveredPyramid === null ||
                  analysis.hoveredPyramid === pyramid
                )
              })}
              fill={color(i)}
              x={xScale(pyramid.age) + width * i}
              y={height - yScale(pyramid.value)}
              width={width}
              height={yScale(pyramid.value)}
            />
            <rect
              className={classnames({
                'bar-target': true,
                hovered: (
                  analysis.hoveredPyramid === null ||
                  analysis.hoveredPyramid === pyramid
                )
              })}
              onMouseOver={() => { analysis.hoveredPyramid = pyramid }}
              onMouseOut={() => { analysis.hoveredPyramid = null }}
              x={xScale(pyramid.age) + width * i}
              y={0}
              width={targetWidth}
              height={height}
            />
          </g>
        ))
      }
    </g>
  )
}

export default observer(Series)
